export default __webpack_public_path__ + "static/media/houserules.3c8e3217.jpg";